// extracted by mini-css-extract-plugin
export default {"heading":"orderSummary_heading__4jl1P","orderSummary":"orderSummary_orderSummary__q7+IH","listItem":"orderSummary_listItem__I11fI","totalAmount":"orderSummary_totalAmount__9zwwE"};